import { useContext, useMemo } from "react";
import { PageContext } from "../page-context";
import { PageContextType } from "../PageContextType";

export function useGeneralTranslationsContext(): PageContextType["generalTranslations"] {
  const { generalTranslations } = useContext(PageContext);

  return useMemo(() => generalTranslations, [generalTranslations]);
}
